// extracted by mini-css-extract-plugin
export default {"modalContainer":"PricingTableSidebar_modalContainer__AaK7x"};